
    export enum UserRoles{
        STUDENT = 1,
        TEACHER = 2,
        ADMIN = 3,
        SUPERADMIN = 4
    }